import IconSort from "../../common/components/icons/IconSort";
import useTranslation from "../../common/translations";
import { useOfferFiltersDispatch, useOfferFiltersState, } from "../context/OfferFiltersContext";
import { useListingLocation } from "../hooks/useListingLocation";
import { buildClearAllUrl, countActiveFilters, getActiveFilterChips, } from "../utils/activeFilters";
import ActiveFiltersChipBar from "./ActiveFiltersChipBar";
import FilterButton from "./FilterButton";
import QuickFilterPill from "./QuickFilterPill";
import React from "react";
export default function QuickFiltersBar() {
    const { t } = useTranslation("offer-filters");
    const { committedState, filterConfig, facetData, pathFilters } = useOfferFiltersState();
    const dispatch = useOfferFiltersDispatch();
    const location = useListingLocation();
    const removableChips = getActiveFilterChips(committedState, filterConfig, facetData, pathFilters, location.pathname, location.search);
    const selectedCount = countActiveFilters(committedState);
    const clearAllUrl = buildClearAllUrl(committedState, location.pathname, location.search);
    return (<div className="flex flex-col -mx-4">
      <div className="flex items-center gap-2 overflow-x-auto py-2 px-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        <FilterButton count={selectedCount} onOpen={() => dispatch({ type: "open_overlay" })}/>
        <button type="button" aria-label={t("sort.label")} onClick={() => dispatch({ type: "open_overlay_sort" })} className="shrink-0 inline-flex items-center justify-center h-10 w-10 rounded-full border border-[#A1A2A5] bg-white text-[#1C2022]">
          <IconSort />
        </button>
        {pathFilters.map((filter) => (<QuickFilterPill key={filter.id} filterId={filter.id}/>))}
      </div>

      <ActiveFiltersChipBar chips={removableChips} clearAllUrl={clearAllUrl} className="overflow-x-auto pb-2 px-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"/>
    </div>);
}
